module.exports = __webpack_public_path__ + "img/category.969aa80d.svg";